// tokenSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TokenState {
  accessToken: string | null;
  refreshToken: string | null;
  expiresIn: number | null;
  usuario: any | null;
}

const initialState: TokenState = {
  accessToken: null,
  refreshToken: null,
  expiresIn: null,
  usuario: null,
};

const tokenSlice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<TokenState>) {
      return { ...state, ...action.payload };
    },
    clearToken() {
      return initialState;
    },
  },
});

export const { setToken, clearToken } = tokenSlice.actions;
export default tokenSlice.reducer;
